// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__-ovk4","errors":"Errors_errors__1v03y"};